import { Button as AntdButton } from 'antd';
import styled from '@emotion/styled';

export const Button = styled(AntdButton)({
  height: 36,
});
